import dummyData from "../../shared/dummyData.json";

const getPlayers = () => dummyData.elements;

const getTeams = () => dummyData.teams;

const fplService = {
  getPlayers,
  getTeams
};

export default fplService;
